import styled from '@emotion/styled';
import { Col } from 'antd';
import React from 'react';

import { color, font, mediaQueries, shadow } from 'src/shared/styles/variables';

import { CardIcon } from '../cpProgram/components/styles';

interface TipCardWrapperProps {
    iswide?: boolean;
}

const TipCardWrapper = styled<any>(Col)<TipCardWrapperProps>(({ iswide }) => ({
    marginBottom: iswide ? '7rem' : '1.75rem',
    padding: '0rem 0.88rem',
    [mediaQueries.sm]: {
        width: '100%',
    },
}));

interface CardContentProps {
    clickable: boolean;
    centered?: boolean;
}

const CardContainer = styled('div')((props: CardContentProps) => ({
    borderRadius: 5,
    boxShadow: shadow.lightCardShadow,
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    border: `1px solid ${color.gallery}`,
    paddingBottom: '1.75rem',
    cursor: props.clickable ? 'pointer' : 'auto',
    transition: 'all 0.2s ease-in-out',
    textAlign: props.centered ? 'center' : 'left',
    '&:hover': {
        borderColor: props.clickable ? color.selectiveYellow : color.gallery,
    },
}));

const CardIconHolder = styled('div')({
    padding: '0.88rem',
    backgroundColor: color.polar,
});

const CardTitle = styled('h3')(
    {
        width: '100%',
        padding: '1.75rem 1.75rem 0rem',
        margin: 0,
        color: color.blueLagoon,
        backgroundColor: color.white,
    },
    font.heavy(font.size.medium),
);

const CardContent = styled('div')(
    {
        padding: '0.88rem 1.75rem 0.00rem',
        color: color.tundora,
    },
    font.book(font.size.medium),
);

interface Props {
    iconUrl: string;
    title: string;
    onClick?: () => void;
    centered?: boolean;
    iswide?: boolean;
}

export const TipCard: React.SFC<Props> = ({
    onClick,
    centered,
    iconUrl,
    title,
    children,
    iswide,
}) => (
    <TipCardWrapper iswide={iswide ? 1 : 0} sm={12} md={iswide ? 12 : 8}>
        <CardContainer onClick={onClick} clickable={onClick != undefined} centered={centered}>
            <CardIconHolder>
                <CardIcon iconUrl={iconUrl} />
            </CardIconHolder>
            <CardTitle>{title}</CardTitle>
            {children && <CardContent>{children}</CardContent>}
        </CardContainer>
    </TipCardWrapper>
);
